import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import {
  faBoxArchive,
  faRedo,
  faTrashAlt,
  faForwardStep,
  faStopCircle,
  faPlayCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const MySwal = withReactContent(Swal);

const Notification = {
  confirm: async function ({
    theme,
    title,
    text,
    icon = "warning",
    confirmButtonText = "Yes",
    cancelButtonText = "Cancel",
  }) {
    return MySwal.fire({
      title,
      text,
      icon,
      showCancelButton: true,
      confirmButtonColor: theme.palette.primary.main,
      cancelButtonColor: theme.palette.success.main,
      confirmButtonText,
      cancelButtonText,
    });
  },

  confirmArchiveDeployment: async function (theme) {
    return MySwal.fire({
      title: "Are you sure you want to Archive this deployment?",
      text: "The deployment will be moved to the Archive database and will still be accessible.",
      icon: "warning",
      iconHtml: <FontAwesomeIcon icon={faBoxArchive} />,
      showCancelButton: true,
      confirmButtonColor: theme.palette.primary.main,
      cancelButtonColor: theme.palette.success.main,
      confirmButtonText: "Yes, archive it!",
    });
  },

  confirmArchiveAllDeployments: async function (theme) {
    return MySwal.fire({
      title: "Are you sure you want to Archive all complete deployment?",
      text: "The deployment(s) will be moved to the Archive database and will still be accessible.",
      icon: "warning",
      iconHtml: <FontAwesomeIcon icon={faBoxArchive} />,
      showCancelButton: true,
      confirmButtonColor: theme.palette.primary.main,
      cancelButtonColor: theme.palette.success.main,
      confirmButtonText: "Yes, archive 'em!",
    });
  },

  confirmRestoreDeployment: async function (theme) {
    return MySwal.fire({
      title: "Are you sure you want to restore this deployment?",
      text: "The deployment will be moved back to the active Deployments database.",
      icon: "question",
      iconHtml: <FontAwesomeIcon icon={faRedo} />,
      showCancelButton: true,
      confirmButtonColor: theme.palette.primary.main,
      cancelButtonColor: theme.palette.success.main,
      confirmButtonText: "Yes, restore it!",
    });
  },

  confirmDeleteDeployment: async function (theme) {
    return MySwal.fire({
      title: "Are you sure you want to delete this deployment?",
      text: "Warning: This will permanently delete the device from the database.",
      icon: "error",
      iconHtml: <FontAwesomeIcon icon={faTrashAlt} />,
      showCancelButton: true,
      confirmButtonColor: theme.palette.primary.main,
      cancelButtonColor: theme.palette.success.main,
      confirmButtonText: "Yes, delete it!",
    });
  },

  confirmDeleteCompany: async function (theme) {
    return MySwal.fire({
      title: "Are you sure you want to delete this company?",
      text: "Warning: This will delete the company from the database. If a new PC is deployed to the company after deletion, the company will be recreated with default applications assigned.",
      icon: "error",
      iconHtml: <FontAwesomeIcon icon={faTrashAlt} />,
      showCancelButton: true,
      confirmButtonColor: theme.palette.primary.main,
      cancelButtonColor: theme.palette.success.main,
      confirmButtonText: "Yes, delete it!",
    });
  },

  confirmSkipDeployment: async function (theme, step) {
    return MySwal.fire({
      title: "Skip Current Step",
      text: `Do you want to skip the '${step}' step?`,
      icon: "question",
      iconHtml: <FontAwesomeIcon icon={faForwardStep} />,
      showCancelButton: true,
      confirmButtonColor: theme.palette.primary.main,
      cancelButtonColor: theme.palette.success.main,
      confirmButtonText: "Yes, skip it!",
    });
  },

  confirmCancelDeployment: async function (theme) {
    return MySwal.fire({
      title: "Are you sure?",
      text: "This will allow JimmyBot to be closed on the remote device. It will also prevent the deployment from continuing, once the running task is complete.",
      icon: "warning",
      iconHtml: <FontAwesomeIcon icon={faStopCircle} />,
      showCancelButton: true,
      confirmButtonColor: theme.palette.primary.main,
      cancelButtonColor: theme.palette.success.main,
      confirmButtonText: "Let's do this!",
    });
  },

  confirmResumeDeployment: async function (theme) {
    return MySwal.fire({
      title: "Are you sure?",
      text: "This will allow JimmyBot to be run again, however it will not actually launch JimmyBot or intitialise PC deployment.",
      icon: "warning",
      iconHtml: <FontAwesomeIcon icon={faPlayCircle} />,
      showCancelButton: true,
      confirmButtonColor: theme.palette.primary.main,
      cancelButtonColor: theme.palette.success.main,
      confirmButtonText: "Let's do this!",
    });
  },

  success: function (theme, title, message) {
    return MySwal.fire({
      title,
      text: message,
      icon: "success",
      confirmButtonColor: theme.palette.success.main,
    });
  },

  error: function (theme, title, message) {
    return MySwal.fire({
      title,
      text: message,
      icon: "error",
      confirmButtonColor: theme.palette.info.main,
    });
  },

  promptForName: async function (theme) {
    const { value: name } = await MySwal.fire({
      title: "👋 Hi there, human!",
      text: "I am JimmyBot, I need to know your name to proceed!",
      input: "text",
      inputLabel: "What's your name?",
      inputPlaceholder: "Enter your name here...",
      inputAttributes: {
        "aria-label": "Your name",
        autocapitalize: "off",
      },
      iconHtml: "🤖", // Use a robot emoji for the icon
      iconColor: theme.palette.primary.main,
      confirmButtonColor: theme.palette.primary.main,
      showCancelButton: true,
      confirmButtonText: "Nice to meet you!",
      cancelButtonText: "Maybe later...",
      allowOutsideClick: false,
      inputValidator: (value) => {
        if (!value || value.trim().length === 0) {
          return "Please enter your name!";
        }
      },
    });

    return name ? name.trim() : null;
  },
};

export default Notification;
